import React, { ReactElement } from "react"

interface Props {}

export default function HdLogo({}: Props): ReactElement {
	return (
		<svg
			className="cursor-pointer"
			width="31"
			height="32"
			viewBox="0 0 31 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M4 0.5H31V27.5L11 19.8585L4 0.5Z" fill="#267CE7" />
			<path d="M0 2.5L7 23.5L29 31.5H0V2.5Z" fill="#1D1F24" />
		</svg>
	)
}
